import { getMaterialOptions } from "../configurator/materials/materialConfig";

// Pricing configuration for the tuinhuis
export const pricingConfig = {
  basePrice: 8000, // Base price for a standard tuinhuis

  // Price calculation functions for each field
  priceRules: {
    // Breedte: price increases with width
    BREEDTE: {
      type: 'linear',
      baseValue: 6000, // Reference value in mm
      pricePerUnit: 0.20, // Euro per mm above base
      formula: (value, baseValue, pricePerUnit) => {
        const difference = value - baseValue;
        return difference > 0 ? difference * pricePerUnit : 0;
      }
    },

    // Lengte: price increases with length
    LENGTE: {
      type: 'linear',
      baseValue: 4000, // Reference value in mm
      pricePerUnit: 0.25, // Euro per mm above base
      formula: (value, baseValue, pricePerUnit) => {
        const difference = value - baseValue;
        return difference > 0 ? difference * pricePerUnit : 0;
      }
    },

    // Wandhoogte: price increases with height
    /*
    HUIS_WAND_HOOGTE: {
      type: 'linear',
      baseValue: 2400, // Reference value in mm
      pricePerUnit: 0.10, // Euro per mm above base
      formula: (value, baseValue, pricePerUnit) => {
        const difference = value - baseValue;
        return difference > 0 ? difference * pricePerUnit : 0;
      }
    },

    // Dakdikte: price per mm
    HUIS_DAK_DIKTE: {
      type: 'perUnit',
      pricePerUnit: 0.50,
      formula: (value, pricePerUnit) => value * pricePerUnit
    },

    // Wanddikte: price per mm
    WAND_DIKTE: {
      type: 'perUnit',
      pricePerUnit: 0.30,
      formula: (value, pricePerUnit) => value * pricePerUnit
    },

    // Vloerdikte: price per mm
    VLOER_DIKTE: {
      type: 'perUnit',
      pricePerUnit: 0.20,
      formula: (value, pricePerUnit) => value * pricePerUnit
    },

    */

    // Deurbreedte: fixed prices per size
    DEUR_BREEDTE: {
      type: 'fixedPrice',
      prices: {
        700: 0,
        800: 0,
        900: 100,
        1000: 200,
        1100: 300,
        1200: 400
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Material prices for wanden
    MATERIAL_WAND: {
      type: 'materialPrice',
      prices: {
        'oak-wood': 1200,
        'bare-wood1': 800,
        'subtle-grained-wood': 1000,
        'streaky-plywood': 600,
        'wood-siding': 900,
        'wood-siding-5': 900,
        'wood-siding-9': 900,
        'wood-siding-13': 900,
        'wood-planks': 850
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Material prices for dak
    MATERIAL_DAK: {
      type: 'materialPrice',
      prices: {
        'streaky-plywood': 400,
        'subtle-grained-wood': 600
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Color surcharge for frame
    KLEUR_FRAME: {
      type: 'colorPrice',
      prices: {
        'RAL 9016': 150,
        'RAL 7016': 150,
        'RAL 8019': 150,
        'RAL 9001': 150,
        'RAL 9005': 200 // Black is slightly more expensive
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Material prices for vloer
    MATERIAL_VLOER: {
      type: 'materialPrice',
      prices: {
        'grainy-concrete': 800,
        'cobblestone-curved': 1200
      },
      formula: (value, prices) => prices[value] || 0
    },

    // Color surcharge for dak
    KLEUR_DAK: {
      type: 'colorPrice',
      prices: {
        'RAL 9016': 200,
        'RAL 7016': 200,
        'RAL 8019': 200,
        'RAL 9001': 200,
        'RAL 9005': 250
      },
      formula: (value, prices) => prices[value] || 0
    }
  }
};

export const formConfig = [


  // =====================================================
  // VOORGEVEL
  // =====================================================
  {
    type: 'subtitle',
    label: 'Gevels',
    name: 'SUBTITLE_VOORGEVEL',
    description: 'Configureer het type gevel van uw tuinhuis'
  },


  {
    type: 'radioPicker',
    label: 'Type voorgevel',
    name: 'VOORGEVEL_TYPE',
    detailed_label: 'Selecteer het type voorgevel voor uw tuinhuis',
    title: 'Type voorgevel',
    description: 'Het type voorgevel bepaalt de indeling en uitstraling van de voorkant van uw tuinhuis.',
    defaultValue: 'extra_raam',
    // Backend communication
    backendType: 'option',  // This field triggers an option operation
    options: [
      {
        value: 'default',
        label: 'Standaard voorgevel',
        description: 'Voorgevel met enkel een deur',
        badge: 'Standaard',
        optionKey: 'Default'
      },
      {
        value: 'standaard',
        label: 'Standaard groot raam',
        description: 'Klassieke voorgevel met deur en raam',
        badge: 'Standaard',
        optionKey: 'WA_01'
      },
      {
        value: 'extra_raam',
        label: 'Voorgevel met twee ramen',
        description: 'Voorgevel met twee ramen',
        badge: 'Premium',
        optionKey: 'WA_05'
      },
    ],
    validation: { required: 'Gelieve een type voorgevel te selecteren' }
  },

  {
    type: 'radioPicker',
    label: 'Type linkergevel',
    name: 'LINKERGEVEL_TYPE',
    detailed_label: 'Selecteer het type linkergevel voor uw tuinhuis',
    title: 'Type linkergevel',
    description: 'Het type linkergevel bepaalt de indeling en uitstraling van de linkerkant van uw tuinhuis.',
    defaultValue: 'Default',
    // Backend communication
    backendType: 'option',  // This field triggers an option operation
    options: [
      {
        value: 'groot_raam',
        label: 'Gevel met raam',
        description: 'Klassieke gevel met raam',
        badge: 'Standaard',
        optionKey: 'WA_02'
      },
      {
        value: 'Default',
        label: 'Gevel zonder raam',
        description: 'Gevel zonder raam',
        optionKey: 'WA_06'
      },
    ],
    validation: { required: 'Gelieve een type linkergevel te selecteren' }
  },

    {
    title: "Materiaal wanden",
    detailed_label: "Welk type hout wenst u voor de wanden?",
    name: "MATERIAL_WAND",
    label: "Materiaal",
    type: "materialPicker",
    description: "Kies het houtsoort voor de wanden van uw tuinhuis. Het materiaal bepaalt de uitstraling, duurzaamheid en onderhoudsvereisten.",
    defaultValue: "wood-planks",
    // Frontend-only: materials are applied locally, no backend call needed
    // Legacy OBJ mesh selector
    meshSelector: {
      type: "exact",
      value: ["Wall"]
    },
    // IFC color selector - matches walls by their IFC color (RGB)
    // Color: rgb(124, 118, 104) = 0.486_0.463_0.408
    ifcColorSelector: {
      type: "rgb",
      value: "0.486_0.463_0.408"
    },
    options: getMaterialOptions(["wood-siding", "wood-siding-5", "wood-planks"]),
    validation: { required: 'Gelieve een materiaal te selecteren' }
  },



  // =====================================================
  // AFMETINGEN
  // =====================================================
  {
    type: 'subtitle',
    label: 'Afmetingen',
    name: 'SUBTITLE_AFMETINGEN',
    description: 'Bepaal de basisafmetingen van uw tuinhuis'
  },

  {
    type: 'dimensionPicker',
    label: 'Afmetingen',
    name: 'DIMENSIONS',
    detailed_label: 'Selecteer de gewenste afmetingen voor uw tuinhuis',
    title: 'Breedte x Lengte',
    description: 'De breedte en lengte van uw tuinhuis bepalen de binnenruimte. Houd rekening met de beschikbare ruimte in uw tuin.',
    displayUnit: 'cm',
    conversionFactor: 10,
    defaultValue: { WIDTH: 9500, HEIGHT: 5000 },
    inputMode: 'slider', // slider of input
    fields: {
      WIDTH: {
        label: 'Breedte (cm)',
        backendKey: 'Breedte',
        placeholder: 'Breedte',
        min: 3000,
        max: 12000,
      },
      HEIGHT: {
        label: 'Lengte (cm)',
        backendKey: 'Lengte',
        placeholder: 'Lengte',
        min: 3000,
        max: 12000,
        step: 300
      }
    },
    validation: {
      WIDTH: {
        required: 'Is verplicht',
        min: { value: 3000, message: 'Moet minimaal 3m zijn' },
        max: { value: 12000, message: 'Mag maximaal 12m zijn' }
      },
      HEIGHT: {
        required: 'Is verplicht',
        min: { value: 3000, message: 'Moet minimaal 3m zijn' },
        max: { value: 12000, message: 'Mag maximaal 12m zijn' }
      }
    }
  },



  /*
  {
    type: 'fixedValuePicker',
    label: 'Wandhoogte',
    name: 'HUIS_WAND_HOOGTE',
    detailed_label: 'Selecteer de gewenste hoogte van de wanden',
    title: 'Wandhoogte',
    description: 'De wandhoogte bepaalt de binnenhoogte van uw tuinhuis. Een hogere wand geeft meer ruimtegevoel.',
    defaultValue: 2500,
    backendKey: 'Huis_Wand_hoogte',
    min: 2100,
    max: 3200,
    step: 300,
    unit: 'mm',
    displayUnit: 'cm',
    conversionFactor: 10,
    validation: {
      required: 'Is verplicht',
      min: { value: 2100, message: 'Moet minimaal 2.1m zijn' },
      max: { value: 3200, message: 'Mag maximaal 3.2m zijn' }
    }
  },

  {
    type: 'radioPicker',
    label: 'Wanddikte',
    name: 'WAND_DIKTE',
    detailed_label: 'Kies de dikte van de wanden',
    title: 'Wanddikte',
    description: 'De wanddikte bepaalt de isolatiewaarde en stevigheid van de wanden. Dikkere wanden bieden betere isolatie.',
    defaultValue: 200,
    backendKey: 'Wand_dikte',
    options: [
      {
        value: 200,
        label: 'Smalle wand',
        description: '20 cm dikte',
        badge: 'Standaard'
      },
      {
        value: 400,
        label: 'Brede wand',
        description: '40 cm dikte',
        badge: 'Extra isolatie'
      }
    ],
    validation: { required: 'Gelieve een wanddikte te selecteren' }
  },


  // =====================================================
  // DAK
  // =====================================================
  {
    type: 'subtitle',
    label: 'Dak',
    name: 'SUBTITLE_DAK',
    description: 'Configureer het dak van uw tuinhuis'
  },

  {
    type: 'radioPicker',
    label: 'Dakdikte',
    name: 'HUIS_DAK_DIKTE',
    detailed_label: 'Kies de dikte van het dak',
    title: 'Dakdikte',
    description: 'De dakdikte bepaalt de isolatiewaarde en stevigheid van het dak. Een dikker dak biedt betere isolatie.',
    defaultValue: 200,
    backendKey: 'Huis_Dak_dikte',
    options: [
      {
        value: 200,
        label: 'Standaard dak',
        description: '20 cm dikte',
        badge: 'Standaard'
      },
      {
        value: 350,
        label: 'Geïsoleerd dak',
        description: '35 cm dikte',
        badge: 'Aanbevolen'
      }
    ],
    validation: { required: 'Gelieve een dakdikte te selecteren' }
  },
*/


  // =====================================================
  // WANDEN
  // =====================================================
  {
    type: 'subtitle',
    label: 'Dak',
    name: 'SUBTITLE_DAK',
    description: 'Configureer het dak van uw tuinhuis'
  },


  {
    title: "Kleur dak",
    detailed_label: "Welke kleur wenst u voor het dak?",
    name: "KLEUR_DAK",
    label: "Kleur dak",
    type: "colorPicker",
    description: "De kleur van het dak bepaalt mede de uitstraling van uw tuinhuis. Kies een kleur die past bij de omgeving en uw woning.",
    defaultValue: "RAL 6009",
    // Frontend-only: colors are applied locally, no backend call needed
    // Legacy OBJ mesh selector
    meshSelector: {
      type: "exact",
      value: ["Dak"]
    },
    // IFC material selector - matches all roof materials: EPDM, OSB top, C18 rand
    ifcMaterialSelector: {
      type: "contains",
      value: ["SH-WD-OSB", "C18"]
    },
    options: [
      { label: "RAL 7016 (antracietgrijs)", color: "#293133", code: "RAL 7016" },
      { label: "RAL 9005 (gitzwart)", color: "#0e0e10", code: "RAL 9005" },
      { label: "RAL 6009 (dennengroen)", color: "#26392f", code: "RAL 6009" },
      { label: "RAL 8017 (chocoladebruin)", color: "#442f29", code: "RAL 8017" },
      { label: "RAL 3009 (oxiderood)", color: "#6d342d", code: "RAL 3009" },
    ],
    validation: { required: 'Gelieve een kleur te selecteren' }
  },

  // =====================================================
  // VLOER
  // =====================================================
  {
    type: 'subtitle',
    label: 'Vloer',
    name: 'SUBTITLE_VLOER',
    description: 'Configureer de vloer van uw tuinhuis'
  },

  {
    type: 'radioPicker',
    label: 'Vloerdikte',
    name: 'VLOER_DIKTE',
    detailed_label: 'Kies de dikte van de vloer',
    title: 'Vloerdikte',
    description: 'De vloerdikte bepaalt de stevigheid en isolatie van de vloer. Een dikkere vloer is geschikt voor zwaardere belasting.',
    defaultValue: 150,
    backendKey: 'Vloer_Dikte',
    options: [
      {
        value: 150,
        label: 'Standaard vloer',
        description: '15 cm dikte',
        badge: 'Standaard'
      },
      {
        value: 250,
        label: 'Versterkte vloer',
        description: '25 cm dikte',
        badge: 'Extra stevig'
      }
    ],
    validation: { required: 'Gelieve een vloerdikte te selecteren' }
  },

  {
    title: "Materiaal vloer",
    detailed_label: "Welk materiaal wenst u voor de vloer?",
    name: "MATERIAL_VLOER",
    label: "Materiaal",
    type: "materialPicker",
    description: "Kies het materiaal voor de vloer rondom uw tuinhuis. Beton is praktisch en onderhoudsvriendelijk, kasseien geven een klassieke uitstraling.",
    defaultValue: "grainy-concrete",
    // Frontend-only: materials are applied locally, no backend call needed
    // Legacy OBJ mesh selector
    meshSelector: {
      type: "exact",
      value: ["Vloer"]
    },
    // IFC material selector - matches floor materials: wood panels and concrete slab
    ifcMaterialSelector: {
      type: "contains",
      value: ["FL-WD-PNL", "SB-CC"]
    },
    options: getMaterialOptions(["grainy-concrete", "cobblestone-curved"]),
    validation: { required: 'Gelieve een materiaal te selecteren' }
  },

  // =====================================================
  // DEUR
  // =====================================================
  {
    type: 'subtitle',
    label: 'Deur',
    name: 'SUBTITLE_DEUR',
    description: 'Configureer de deur van uw tuinhuis'
  },

  {
    type: 'selectPicker',
    label: 'Type deur',
    name: 'DEUR_BREEDTE',
    detailed_label: 'Selecteer het type deur voor uw tuinhuis',
    title: 'Type deur',
    description: 'Kies het type deur dat het beste past bij uw wensen. Elk type heeft zijn eigen afmetingen en eigenschappen.',
    defaultValue: 900,
    backendKey: 'Deur_Breedte_deur',
    placeholder: 'Selecteer een deurtype...',
    options: [
      {
        value: 900,
        label: 'Standaard deur',
        description: '90 × 210 cm',
        badge: 'Standaard'
      },
      {
        value: 1000,
        label: 'Brede deur',
        description: '100 × 210 cm'
      },
      {
        value: 1500,
        label: 'Dubbele deur',
        description: '150 × 210 cm',
        badge: 'Aanbevolen'
      },
      {
        value: 1800,
        label: 'Schuifdeur',
        description: '180 × 220 cm'
      },
      {
        value: 2000,
        label: 'Openslaande deuren',
        description: '200 × 210 cm',
        badge: 'Premium'
      }
    ],
    validation: { required: 'Gelieve een deurtype te selecteren' }
  },

  {
    type: 'fixedValuePicker',
    label: 'Deurpositie',
    name: 'DEUR_POSITIE',
    detailed_label: 'Selecteer de positie van de deur (afstand vanaf voorgevel)',
    title: 'Deurpositie',
    description: 'De afstand van de deur tot de zijkant van de voorgevel. Pas dit aan om de deur links, rechts of in het midden te plaatsen.',
    defaultValue: 2500,
    backendKey: 'Deur_afst_01',
    min: 500,
    max: 5000,
    step: 100,
    unit: 'mm',
    displayUnit: 'cm',
    conversionFactor: 10,
    validation: {
      required: 'Is verplicht',
      min: { value: 500, message: 'Moet minimaal 50cm zijn' },
      max: { value: 5000, message: 'Mag maximaal 5m zijn' }
    }
  },

  {
    title: "Kleur deur",
    detailed_label: "Welke kleur wenst u voor het metalen frame van de deur?",
    name: "KLEUR_DEUR",
    label: "Kleur frame",
    type: "colorPicker",
      opacity: 1, 
    description: "Het metalen frame verbindt de constructie-elementen. Kies een kleur die past bij uw tuinhuis of tuin. Het frame is gemaakt van gepoedercoat staal voor maximale duurzaamheid.",
    defaultValue: "RAL 6009",
    // Frontend-only: colors are applied locally, no backend call needed
    // Legacy OBJ mesh selector
    /*meshSelector: {
      type: "exact",
      value: ["Door", "Raam_Zijkant"]
    },*/
    //IFC material selector - TODO: bepaal welk materiaal de deur is
     ifcColorSelector: {
       type: "exact",
       value: ["1.000_0.988_0.941_1.000","1.000_1.000_1.000_0.200"]
     },
    options: [
      { label: "RAL 7016 (antracietgrijs)", color: "#293133", code: "RAL 7016", opacity: 1  },
      { label: "RAL 9005 (gitzwart)", color: "#0e0e10", code: "RAL 9005", opacity: 1 },
      { label: "RAL 7021 (zwartgrijs)", color: "#2f3234", code: "RAL 7021", opacity: 1 },
      { label: "RAL 6009 (dennengroen)", color: "#26392f", code: "RAL 6009", opacity: 1 },
      { label: "RAL 8014 (sepiabruin)", color: "#4a3526", code: "RAL 8014", opacity: 1 },
    ],
    validation: { required: 'Gelieve een kleur te selecteren' }
  },


];
